<template>
  <div class="w-full">
    <div class="px-16 pt-16">
      <p class="text-2xl font-bold mb-8">
        {{ $t("message.publishDocuments.configMassivePublish.title") }}
      </p>

      <div
        v-if="getRelated.length > 1"
        class="
          alert-company
          border
          rounded
          border-0
          flex
          py-6
          px-4
          mb-6
          bg-certs-info
        "
      >
        <div class="flex justify-center items-center ml-1 mr-4">
          <zt-icon name="info" class="info-icon" />
        </div>
        <p class="info-text text-zt-base font-normal self-center">
          {{ $t("message.publishDocuments.configMassivePublish.companyAlert") }}
          <span class="font-bold">{{ company }}</span>
        </p>
      </div>
      <div class="mb-6">
        <p class="text-xl font-medium mb-6">
          {{ $t("message.publishDocuments.configMassivePublish.monthTitle") }}
        </p>
        <p class="text-sm w-11/12 text-zt-dark-300">
          {{ $t("message.publishDocuments.configMassivePublish.monthContent") }}
        </p>
        <div class="py-4 w-1/2">
          <div class="border border-zt-dark-400 rounded px-2 relative">
            <label
              v-if="!period"
              class="
                label-input
                px-2
                text-zt-dark-400 text-base
                bg-white
                absolute
                cursor-pinter
              "
              >{{
                $t("message.publishDocuments.configMassivePublish.monthSelect")
              }}</label
            >
            <datepicker
              :minimumView="'month'"
              :maximumView="'month'"
              :disabled-dates="disabledDates"
              :language="languageDatePicker"
              name="fecha_baja"
              id="fecha_baja"
              format="MMMM yyyy"
              :bootstrap-styling="true"
              clear-button-icon="fa fa-times"
              :clear-button="true"
              v-model="period"
              input-class="w-full focus:outline-none border-0"
            >
            </datepicker>
          </div>
        </div>
      </div>
      <div class="mb-6">
        <p class="text-xl font-medium mb-6">
          {{
            $t(
              "message.publishDocuments.configMassivePublish.documentTypeTitle"
            )
          }}
        </p>
        <p class="text-sm w-11/12 text-zt-dark-300">
          {{
            $t(
              "message.publishDocuments.configMassivePublish.documentTypeContent"
            )
          }}
        </p>
        <div class="py-4">
          <div class="border border-zt-dark-400 rounded px-2 relative w-5/6">
            <label
              class="
                label-input
                px-2
                text-zt-dark-300 text-base
                bg-white
                absolute
              "
              :class="{
                labelInputActive: typeOfDocumentSelected || multiselectActive,
              }"
              >{{
                $t(
                  "message.publishDocuments.configMassivePublish.documentTypeSelect"
                )
              }}</label
            >
            <MultiSelect
              v-model="typeOfDocumentSelected"
              name="cargo"
              :options="documents"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder=""
              group-values="childs"
              group-label="name"
              label="name"
              track-by="id"
              @open="multiselectActive = true"
              @close="multiselectActive = false"
              @select="setFolderId"
            >
            </MultiSelect>
          </div>
          <div
              class="text-zt-info font-normal text-zt-primary-200 mt-2 flex items-center justify-start"
              v-if="signMessage"
            >
              <zt-icon
                name="exclamation-circle-outline"
                class="text-zt-warning mr-2"
                :style="{ fontSize: '2rem' }"
              />
              <span>
                {{ signMessage }}
              </span>
            </div>
        </div>
      </div>
      <div class="mb-6" ref="processSection">
        <p class="text-xl font-medium mb-6">
          {{
            $t(
              "message.publishDocuments.configMassivePublish.documentProcessTitle"
            )
          }}
        </p>
        <p class="text-sm w-11/12 text-zt-dark-300">
          {{
            $t(
              "message.publishDocuments.configMassivePublish.documentProcessContent"
            )
          }}
        </p>
        <div class="py-4">
          <div v-if="ishasFnParser" class="mb-4 h-info w-full bg-certs-info">
            <div class="w-full h-full flex">
              <div
                class="w-info-icon flex justify-center items-center ml-3 mr-2"
              >
                <zt-icon name="info" class="info-icon" />
              </div>
              <div class="flex items-center leading-tight px-2 pr-4 mr-4">
                <template>
                  <span class="info-text text-zt-base font-normal">
                    {{
                      $t(
                        "message.publishDocuments.configMassivePublish.hasFnParser"
                      )
                    }}</span
                  >
                </template>
              </div>
            </div>
          </div>
          <template v-if="showCertAlert">
            <div class="mb-4 h-info w-full bg-certs-info">
              <div v-if="!hasEmailCertRecipients" class="w-full h-full flex">
                <div
                  class="w-info-icon flex justify-center items-center ml-3 mr-2"
                >
                  <zt-icon name="info" class="info-icon" />
                </div>
                <div class="flex items-center leading-tight px-2 pr-4">
                  <template>
                    <span class="info-text text-zt-base font-normal">
                      {{
                        $t(
                          "message.publishDocuments.configMassivePublish.emailCertEmptyRecipients"
                        )
                      }}</span
                    >
                  </template>
                </div>
              </div>
              <div v-else class="w-full h-full flex">
                <div
                  class="w-info-icon flex justify-center items-center ml-3 mr-2"
                >
                  <zt-icon name="info" class="info-icon" />
                </div>
                <div class="w-info-text flex items-center leading-tight px-2">
                  <template
                    v-if="
                      !certs.has_certificate_enabled &&
                      certs.has_permissions_to_create &&
                      hasEmailCertRecipients
                    "
                  >
                    <span class="info-text text-zt-base font-normal">
                      {{
                        $t(
                          "message.publishDocuments.configMassivePublish.hasCertEnabled"
                        )
                      }}</span
                    >
                  </template>
                  <template
                    v-if="
                      !certs.has_certificate_enabled &&
                      !certs.has_permissions_to_create &&
                      hasEmailCertRecipients
                    "
                  >
                    <span class="info-text text-zt-base font-normal">{{
                      textCertificateEnabledAlert
                    }}</span>
                  </template>
                  <template
                    v-if="
                      certs.has_certificate_enabled &&
                      !certs.has_employer_signature &&
                      hasEmailCertRecipients
                    "
                  >
                    <span class="info-text text-zt-base font-normal">
                      {{
                        $t(
                          "message.publishDocuments.configMassivePublish.noSignPosition"
                        )
                      }}</span
                    >
                  </template>
                </div>
                <div
                  class="w-info-button flex items-center justify-center mx-4"
                >
                  <template
                    v-if="
                      !certs.has_certificate_enabled &&
                      certs.has_permissions_to_create &&
                      !certs.has_fn_parser &&
                      hasEmailCertRecipients
                    "
                  >
                    <zt-button
                      class="info-button"
                      style="width: 10rem"
                      outlined
                      @click="$router.push('/certificates')"
                    >
                      {{
                        $t(
                          "message.publishDocuments.configMassivePublish.createCert"
                        )
                      }}</zt-button
                    >
                  </template>
                  <template
                    v-if="
                      !certs.has_certificate_enabled &&
                      !certs.has_permissions_to_create &&
                      hasEmailCertRecipients
                    "
                  >
                    <zt-button
                      class="info-button"
                      style="padding-inline: 4px !important"
                      outlined
                      :loader="isLoaderBtnCertificated"
                      :disabled="isBtnCertificateDisabled"
                      @click="sendCertificateNotification"
                      >{{ btnCertificateNotificationText }}</zt-button
                    >
                  </template>
                  <template
                    v-if="
                      certs.has_certificate_enabled &&
                      !certs.has_employer_signature &&
                      hasEmailCertRecipients
                    "
                  >
                    <zt-button
                      class="info-button"
                      style="width: 14rem"
                      outlined
                      @click="
                        $router.push(
                          `/folder/${idFolder}/subfolder/${idSubfolder}`
                        )
                      "
                      >{{
                        $t(
                          "message.publishDocuments.configMassivePublish.configSignPosition"
                        )
                      }}</zt-button
                    >
                  </template>
                </div>
              </div>
            </div>
          </template>
          <div>
            <zt-radio-button
              class="font-bold text-base"
              value="onlyPublish"
              name="doc-process"
              v-model="processDocumentsTypeSelected"
            >
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.documentProcessNone"
                )
              }}
            </zt-radio-button>
            <div class="text-base text-zt-dark-300 ml-12">
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.documentProcessNoneContent"
                )
              }}
            </div>
          </div>
          <div>
            <zt-radio-button
              class="font-bold text-base"
              value="split_crop_and_sign"
              name="doc-process"
              v-model="processDocumentsTypeSelected"
              :disabled="processDisabler[1]"
              :class="{ 'zt-radiobutton--disabled': processDisabler[1] }"
            >
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.documentProcessSplitSign"
                )
              }}
            </zt-radio-button>

            <div class="text-base text-zt-dark-300 ml-12">
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.documentProcessSplitSignContent"
                )
              }}
            </div>
          </div>
          <div>
            <zt-radio-button
              class="font-bold text-base"
              value="split_and_crop"
              name="doc-process"
              v-model="processDocumentsTypeSelected"
              :disabled="processDisabler[2]"
              :class="{ 'zt-radiobutton--disabled': processDisabler[2] }"
            >
              <div class="flex items-center">
                <span>
                  {{
                    $t(
                      "message.publishDocuments.configMassivePublish.documentProcessSplit"
                    )
                  }}
                </span>
              </div>
            </zt-radio-button>

            <div class="text-base text-zt-dark-300 ml-12">
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.documentProcessSplitContent"
                )
              }}
            </div>
          </div>
          <div>
            <zt-radio-button
              class="font-bold text-base"
              value="sign_and_publish"
              name="doc-process"
              v-model="processDocumentsTypeSelected"
              :disabled="processDisabler[3]"
              :class="{ 'zt-radiobutton--disabled': processDisabler[3] }"
            >
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.documentProcessOnlySign"
                )
              }}
            </zt-radio-button>

            <div class="text-base text-zt-dark-300 ml-12">
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.documentProcessOnlySignContent"
                )
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="mb-6">
        <p class="text-xl font-medium mb-6">
          {{
            $t("message.publishDocuments.configMassivePublish.sendEmailTitle")
          }}
        </p>
        <p class="text-sm w-11/12 text-zt-dark-300">
          {{
            $t("message.publishDocuments.configMassivePublish.sendEmailContent")
          }}
        </p>
        <div class="py-4 w-3/4">
          <zt-input
            v-model="email"
            :key="emailKey"
            :label="$t('message.publishDocuments.configMassivePublish.email')"
            outlined
            append-icon="pencil-solid"
            v-validate="'required|email'"
            data-vv-name="email"
            :color="errors.has('email') ? 'secondary' : 'primary'"
          />
          <div
            class="text-base text-zt-danger my-3 md:my-3"
            v-show="errors.has('email')"
          >
            <span v-show="errors.has('email')" class="help is-danger">{{
              errors.first("email")
            }}</span>
          </div>
        </div>
      </div>
      <div class="mb-6">
        <p class="text-xl font-medium mb-6">
          {{
            $t(
              "message.publishDocuments.configMassivePublish.sendEmailCollabTitle"
            )
          }}
        </p>
        <p class="text-sm w-11/12 text-zt-dark-300">
          {{
            $t(
              "message.publishDocuments.configMassivePublish.sendEmailCollabContent"
            )
          }}
        </p>
        <p class="text-sm w-11/12 text-zt-dark-300">
          {{
            $t(
                "message.publishDocuments.configMassivePublish.sendEmailCollabContentPush"
            )
          }}
        </p>
        <div class="py-4">
          <div>
            <zt-radio-button
              class="font-medium text-base"
              :value="true"
              name="send-email"
              v-model="sendNotification"
            >
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.sendEmailCollabYes"
                )
              }}
            </zt-radio-button>
          </div>
          <div>
            <zt-radio-button
              class="font-medium text-base"
              :value="false"
              name="send-email"
              v-model="sendNotification"
            >
              {{
                $t(
                  "message.publishDocuments.configMassivePublish.sendEmailCollabNo"
                )
              }}
            </zt-radio-button>
          </div>
          <div>
            <zt-check-box
              class="font-medium text-base"
              :class="{ 'opacity-50': !state.sendNotification}"
              name="send-push"
              v-model="sendPushNotification"
              :disabled="!state.sendNotification"
            >
              {{
                $t(
                    "message.publishDocuments.configMassivePublish.sendPushCollab"
                )
              }}
            </zt-check-box>
          </div>
        </div>
      </div>
      <ModalEnterEmail
        :value="isActiveModalEnterEmail"
        :userName="nameUserCreateCert"
        @close-modal="closeEmailModal"
        @send-notification="sendCertificateNotificationEmail"
      />
    </div>
    <div class="footer p-10 flex justify-end">
      <zt-button
        class="cancel-button text-base font-bold"
        text
        @click="$emit('cancel-process')"
        >{{
          $t("message.publishDocuments.configMassivePublish.btnCancel")
        }}</zt-button
      >
      <zt-button
        class="text-base font-bold ml-2"
        @click="$emit('goto-next-step')"
        :disabled="disableButton"
        >{{
          $t("message.publishDocuments.configMassivePublish.btnNext")
        }}</zt-button
      >
    </div>
  </div>
</template>

<script>
import datepicker from "vuejs-datepicker";
import { es, ptBR } from "vuejs-datepicker/dist/locale";
import MultiSelect from "vue-multiselect";
import Folders from "@/apiClient/Folders";
import Certificates from "@/apiClient/Certificates";
import Companies from "@/apiClient/Company";
import { mapGetters } from "vuex";
import ModalEnterEmail from "./modalEmail/modalEnterEmail";

import moment from "moment";

export default {
  inject: ["state", "mutations"],
  name: "MassivePublish",
  components: {
    ModalEnterEmail,
    datepicker,
    MultiSelect,
  },
  data() {
    return {
      es,
      ptBR,
      period: this.state.period,
      foldersInstance: new Folders(),
      certificates: new Certificates(),
      companies: new Companies(),
      documents: [],
      typeOfDocumentSelected: this.state.documentType,
      multiselectActive: false,
      processDocumentsTypeSelected: "",
      sendNotification: this.state.sendNotification,
      sendPushNotification: this.state.sendPushNotification,
      email: this.state.email,
      emailKey: 1,
      certs: null,
      checkingCerts: false,
      statusBtnCertificate: 0,
      isBtnCertificateDisabled: false,
      isLoaderBtnCertificated: false,
      idFolder: "",
      idSubfolder: "",
      isActiveModalEnterEmail: false,
      notificationEmail: "",
      ishasFnParser: false,
      nameUserCreateCert: "",
      hasEmailCertRecipients: true,
      disabledDates: {
        to: "",
        from: "",
      },
      processDisabler: [false, false, false, false],
    };
  },

  computed: {
    ...mapGetters(["getRelated", "getUser"]),
    company() {
      return this.getUser.empresa.nombre;
    },
    languageDatePicker() {
      return this.getUser.pais === 'BR' ? this.ptBR : this.es;
    },
    invalidEmail() {
      return this.errors.has("email");
    },
    isAlertOn() {
      return this.ishasFnParser || this.showCertAlert;
    },
    disableButton() {
      if (
        !this.state.documentType ||
        !this.state.period ||
        this.checkingCerts ||
        this.showCertAlert ||
        this.invalidEmail
      ) {
        return true;
      } else {
        return false;
      }
    },
    showCertAlert() {
      if (this.certs) {
        if (
          !this.certs.has_certificate_enabled ||
          (!this.certs.has_certificate_enabled &&
            !this.certs.has_permissions_to_create) ||
          !this.certs.has_employer_signature
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    btnCertificateNotificationText() {
      const btnText = {
        0: this.$t(
          "message.publishDocuments.configMassivePublish.contactAdmin"
        ),
        1: this.$t(
          "message.publishDocuments.configMassivePublish.sending"
        ),
        2: this.$t(
          "message.publishDocuments.configMassivePublish.messageSent"
        ),
        3: this.$t(
          "message.publishDocuments.configMassivePublish.enterEmail"
        ),
      };
      return btnText[this.statusBtnCertificate];
    },

    textCertificateEnabledAlert() {
      const textAlert =
        this.statusBtnCertificate === 3
          ? this.$t("message.publishDocuments.configMassivePublish.noEmail")
          : this.$t(
              "message.publishDocuments.configMassivePublish.noPermissionCert"
            );
      return textAlert;
    },
    signMessage() {
      if (!this.typeOfDocumentSelected) return ''
      return this.typeOfDocumentSelected && this.typeOfDocumentSelected.firmable
        ? this.$t(
            "message.publishDocuments.configMassivePublish.hasSignRequired"
          )
        : this.$t(
            "message.publishDocuments.configMassivePublish.noSignRequired"
          );
    }
  },

  methods: {
    async checkEnabledCerts(processType) {
      this.checkingCerts = true;
      if (
        (processType === "split_crop_and_sign" ||
          processType === "split_and_crop" ||
          processType === "sign_and_publish") &&
        this.typeOfDocumentSelected
      ) {
        const {
          data: { data },
        } = await this.certificates.getCertificateEnabled(
          this.typeOfDocumentSelected.id
        );
        this.certs = data;
        if (processType === "split_and_crop") {
          this.certs.has_certificate_enabled = true;
          this.certs.has_employer_signature = true;
        }
        if (processType !== "sign_and_publish") {
          this.ishasFnParser = this.certs.has_fn_parser;
          if (this.certs.has_fn_parser) {
            this.disableByParserTrue();
          } else {
            this.disableByParserFalse();
          }
        }
        this.checkingCerts = false;
      } else {
        this.certs = null;
        this.checkingCerts = false;
      }
    },

    async sendCertificateNotification() {
      if (this.statusBtnCertificate === 3) {
        this.isActiveModalEnterEmail = true;
      } else {
        this.isBtnCertificateDisabled = true;
        this.isLoaderBtnCertificated = true;
        this.statusBtnCertificate = 1;
        await this.certificates
          .sendNotificationNewCertificate()
          .then((response) => {
            this.statusBtnCertificate = 2;
            this.isLoaderBtnCertificated = false;
          })
          .catch((error) => {
            this.isLoaderBtnCertificated = false;
            this.isBtnCertificateDisabled = false;
            const {
              data: { codes },
            } = error.response;
            const [code] = codes;
            if (code.data) {
              const { name } = code.data;
              this.nameUserCreateCert = name;
            }
            if (code.code === "EMAIL_CERTIFICATE_INVALID_RECIPIENT_EXCEPTION") {
              this.statusBtnCertificate = 3;
            }
            if (code.code === "EMAIL_CERTIFICATE_EMPTY_RECIPIENTS_EXCEPTION") {
              this.hasEmailCertRecipients = false;
              this.statusBtnCertificate = 4;
            }
          });
      }
    },
    closeEmailModal() {
      this.isActiveModalEnterEmail = false;
    },
    async sendCertificateNotificationEmail(emailNotification) {
      this.isActiveModalEnterEmail = false;
      this.isBtnCertificateDisabled = true;
      this.statusBtnCertificate = 1;
      await this.certificates
        .sendNotificationNewCertificate(emailNotification)
        .then((response) => {
          this.statusBtnCertificate = 2;
        })
        .catch((error) => {
          this.statusBtnCertificate = 3;
        });
    },
    setFolderId(value) {
      let documentFolder = this.documents.find((document) =>
        document.childs.some((item) => item.id === value.id)
      );
      this.idFolder = documentFolder.id;
      this.idSubfolder = value.id;
    },
    changeProcessTypeOnBtnDisableByDoc() {
      if (!this.typeOfDocumentSelected.firmable) {
        if (
          this.processDocumentsTypeSelected === "split_crop_and_sign" ||
          this.processDocumentsTypeSelected === "sign_and_publish"
        ) {
          this.processDocumentsTypeSelected = "onlyPublish";
        }
      }
    },
    changeProcessTypeOnBtnDisableByParser() {
      if (this.typeOfDocumentSelected.firmable) {
        if (
          this.processDocumentsTypeSelected === "split_crop_and_sign" ||
          this.processDocumentsTypeSelected === "split_and_crop"
        ) {
          this.processDocumentsTypeSelected = "onlyPublish";
        }
      } else if (this.processDocumentsTypeSelected === "split_and_crop") {
        this.processDocumentsTypeSelected = "onlyPublish";
      }
    },
    cleanForm() {
      (this.period = ""), (this.typeOfDocumentSelected = null);
    },
    async setDateLimits() {
      this.companies.getPublicationDateRange().then((response) => {
        const {
          data: { min_period, max_period },
        } = response.data;
        this.disabledDates.to = new Date(
          min_period.year,
          min_period.month - 1,
          1
        );
        this.disabledDates.from = new Date(
          max_period.year,
          max_period.month - 1,
          1
        );
      });
    },
    focusAlert() {
      this.$refs.processSection.scrollIntoView();
    },
    changeDisableByDoc() {
      this.typeOfDocumentSelected.firmable
        ? (this.processDisabler = ["firmable", false, false, false])
        : ((this.processDisabler = ["notFirmable", true, false, true]),
          this.changeProcessTypeOnBtnDisableByDoc());
    },
    disableByParserTrue() {
      this.typeOfDocumentSelected.firmable
        ? (this.processDisabler = ["firmable", true, true, false])
        : (this.processDisabler = ["notFirmable", true, true, true]);

      this.changeProcessTypeOnBtnDisableByParser();
    },
    disableByParserFalse() {
      this.typeOfDocumentSelected.firmable
        ? (this.processDisabler = ["firmable", false, false, false])
        : (this.processDisabler = ["notFirmable", true, false, true]);
    },
  },
  watch: {
    isAlertOn: function () {
      if (this.isAlertOn) {
        this.focusAlert();
      }
    },
    processDocumentsTypeSelected: async function (val) {
      this.$emit("next-step", val);
      await this.checkEnabledCerts(val);
    },
    period: function (val) {
      this.mutations.setPeriod(moment(val).format("MM/YYYY"));
    },
    typeOfDocumentSelected: function (val) {
      this.ishasFnParser = false;
      this.mutations.setDocumentType(val);
      this.changeDisableByDoc();
      this.checkEnabledCerts(this.processDocumentsTypeSelected);
    },
    email: function (val) {
      this.mutations.setCompanyEmail(val);
    },
    sendNotification: function (val) {
      if (val === false) {
        this.sendPushNotification = false
        this.mutations.setSendPushNotification(false);
      }
      this.mutations.setSendNotification(val);
    },
    sendPushNotification(val) {
      this.mutations.setSendPushNotification(val);
    },
  },
  async created() {
    this.setDateLimits();
    this.processDocumentsTypeSelected = "onlyPublish";
    const params = { hideEforms: true };
    const response = await this.foldersInstance.getFoldersGroup(params);

    const {
      data: { data },
    } = response;
    this.documents = data.map((item) => {
      item.childs = item.childs.map((child) => {
        return {
          ...child,
          firmable: item.firmable,
        };
      });
      return item;
    });
    if (this.getUser.mail) {
      this.email = this.getUser.mail;
      this.emailKey++;
    }
  },
  mounted() {
    this.cleanForm();
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #eeeeee;
}
.label-input {
  top: 10px;
}
.labelInputActive {
  transform: translate(0px, -18px);
  font-size: 0.75rem;
}
::v-deep .zt-label-active {
  top: 7px;
}
::v-deep .multiselect__content-wrapper {
  width: fit-content;
  min-width: 100%;
  border: solid 1px rgba(0, 0, 0, 0.12);
  border-radius: 3px;
}

::v-deep .multiselect__tags {
  background-color: transparent;
  border: none;
  padding: 8px 38px 0 0;
}

::v-deep .multiselect__select {
  padding-left: 16px;
}

.viewer--container {
  height: 489px;
}

::v-deep .multiselect__option {
  padding-left: 2rem;
}
::v-deep .multiselect__option--group {
  background: transparent;
  font-weight: bold;
  padding: 1rem;
}
::v-deep .multiselect__option--selected,
::v-deep .multiselect__option--highlight {
  background-color: #e7e8ff !important;
  color: #707070;
  font-weight: normal;
}

::v-deep .zt-radiobutton {
  .zt-radiobutton-icon {
    font-size: 1.25rem;
  }
  .zt-radiobutton-ripple {
    width: 2rem;
    height: 2rem;
    left: -8px;
    top: calc(50% - 21px);
  }
}
::v-deep .cancel-button {
  color: #575757 !important;
  background-color: transparent !important;
}
.bg-certs-info {
  background: #def3ff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}
.h-info {
  height: 7rem;
}
.w-info-icon {
  width: 12%;
}
.w-info-text {
  width: 80%;
}
.w-info-button {
  width: 38%;
}

.info-text {
  color: #017eec !important;
  opacity: 1 !important;
}
.info-button {
  background: #def3ff 0% 0% no-repeat padding-box !important;
  opacity: 1;
}
.info-icon {
  color: #def3ff !important;
  background: #017eec !important;
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem !important;
}
::v-deep .zt-button-text {
  font-size: 1rem;
}
</style>
